import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useParamsLegacy as useParams } from '@leagueplatform/routing';
import { track } from '@leagueplatform/analytics';
import { CHALLENGE_CAMPAIGN_TYPE } from '#constants/analytics.constants.tsx';
import { useGetChallengeByIdData } from '#pages/challenge-landing-page/hooks/use-get-challenge-by-id-data.hook.ts';
import {
  patchChallengeTeam,
  CHALLENGE_PATCH_OPERATIONS,
  CHALLENGE_HIGHLIGHTS_PATH,
  CHALLENGES_PATH,
} from '@leagueplatform/health-journey-api';
import { toastActions, TOAST_STATUS } from '@leagueplatform/toast-messages';
import { TEAM_BY_ID_QUERY_KEY } from '#pages/team-landing-page/hooks/use-get-team-data-by-id.hook.ts';

export const PATCH_JOIN_AND_LEAVE_TEAM_QUERY_KEY = 'patchJoinAndLeaveTeam';

export const useJoinOrLeaveTeam = (
  teamName: string,
  operationType: CHALLENGE_PATCH_OPERATIONS,
  setDisplayJoinTeamSuccessModal: React.Dispatch<React.SetStateAction<boolean>>,
  setDisplayCantJoinTeamModal: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  const queryClient = useQueryClient();
  const { challengeId } = useParams<{ challengeId: string }>();
  const { teamId } = useParams<{ teamId: string }>();
  const { data: challengeData } = useGetChallengeByIdData();
  const handleAnalyticsClick = () => {
    if (challengeData?.data) {
      track('challenges.button_clicked.team_detail.join_team', {
        team_id: teamId || '',
        team_name: teamName || '',
        health_campaign_id: challengeId || '',
        health_campaign_name: challengeData.data.title || '',
        health_campaign_type: CHALLENGE_CAMPAIGN_TYPE,
      });
    }
  };
  return useMutation(
    () => patchChallengeTeam(teamId, challengeId, operationType),

    {
      onSuccess: () => {
        if (operationType === CHALLENGE_PATCH_OPERATIONS.ADD) {
          setDisplayJoinTeamSuccessModal(true);
          handleAnalyticsClick();
        } else {
          toastActions.add({
            type: TOAST_STATUS.SUCCESS,
            textId: 'SUCCESSFULLY_LEFT_TEAM',
            shouldAutoClose: true,
            values: {
              teamName,
            },
          });
        }
        // Invalidate highlights feed, team data, challenge landing page
        queryClient.invalidateQueries([CHALLENGE_HIGHLIGHTS_PATH]);
        queryClient.invalidateQueries([TEAM_BY_ID_QUERY_KEY]);
        queryClient.invalidateQueries([CHALLENGES_PATH, challengeId]);
      },
      onError: () => {
        if (operationType === CHALLENGE_PATCH_OPERATIONS.ADD) {
          setDisplayCantJoinTeamModal(true);
        } else {
          toastActions.add({
            type: TOAST_STATUS.ERROR,
            textId: 'LEAVE_TEAM_FAILURE',
            shouldAutoClose: false,
          });
        }
      },
    },
  );
};
